import axios from "axios";
import { sweetAlert } from "../utils/UniversalFunction";

export async function apiCall(url, header = {}, data = {}, method = "GET", showIcon = true, showSweetAlert = true, message = null, submessage = null, axiosConfig = {}) {
  let currentUser;
  let config;

  const safeAxiosConfig = (axiosConfig && typeof axiosConfig === "object") ? axiosConfig : {};
  const { headers: extraHeaders, ...restAxiosConfig } = safeAxiosConfig;

  // Base headers
  config = {
    withCredentials: true,
    ...restAxiosConfig,
    headers: {
      ...header,
      ...(extraHeaders || {}),
      Accept: "application/json",
    },
  };

  if (localStorage.getItem("currentUser")) {
    currentUser = JSON.parse(localStorage.getItem("currentUser"));
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    config.headers.userId = currentUser.id;
    if (currentUser.company_id != null) {
      config.headers["x-company-id"] = currentUser.company_id;
    }
  }

  try {
    let response;
    const upperMethod = method.toUpperCase();

    if (upperMethod === "GET") {
      const queryParams = Object.entries(data)
        .map(([key, value]) => {
          if (Array.isArray(value)) {
            return `${key}=[${value.join(",")}]`;
          }
          return `${key}=${value}`;
        })
        .join("&");
      response = await axios.get(`${url}${queryParams ? `?${queryParams}` : ''}`, config);

    } else if (upperMethod === "DELETE") {
      // axios.delete needs data in config object
      response = await axios.delete(url, { ...config, data });

    } else if (upperMethod === "PUT") {
      response = await axios.put(url, data, config);

    } else if (upperMethod === "POST") {
      response = await axios.post(url, data, config);

    } else if (upperMethod === "PATCH") {
      response = await axios.patch(url, data, config);

    } else {
      // ⬇️ detect FormData
      if (!(data instanceof FormData)) {
        // append default role only if data is plain object
        data = { current_role: localStorage.getItem("role"), ...data };
        config.headers["Content-Type"] = "application/json";
      } else {
        // let browser set Content-Type with boundary
        config.headers["Content-Type"] = "multipart/form-data";
        data.append("current_role", localStorage.getItem("role") || "");
      }

      response = await axios[method.toLowerCase()](url, data, config);
    }

    const { status, data: responseData, headers: responseHeaders } = response;

    if (status >= 200 && status < 300) {
      if (method.toUpperCase() !== "GET") {
        if (!responseData?.notShowPopUp) {
          if (showSweetAlert) {
            sweetAlert("success", message || submessage || responseData?.message, showIcon);
          }
        }
      }
      return { status, isSuccess: true, data: responseData, message: responseData?.message, headers: responseHeaders };
    } else {
      throw new Error(`Request failed with status ${status}`);
    }
  } catch (error) {
    const status = error.response?.status;
    let parsedFromBlob;
    if (typeof Blob !== "undefined" && error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        parsedFromBlob = JSON.parse(text);
      } catch { /* leave undefined */ }
    }
    const message = parsedFromBlob?.message || error.response?.data?.message || "An error occurred";

    console.log(status, message);

    // ✅ Only logout on explicit auth errors
    if (message === "SESSION_EXPIRED") {
      sweetAlert("error", "Your Session has expired. Please log in again.", showIcon);
      localStorage.clear();
      window.location.href = "/";
      return;
    } else {
      if (showSweetAlert) {
        sweetAlert("error", message, showIcon);
      }
      return { status, isSuccess: false, data: { error: message }, message, errorBody: parsedFromBlob || error.response?.data };
    }
  }
}
